export const formatSecondsToMMSS = (totalSeconds: number): string => {
  const safeSeconds = Math.max(0, Math.floor(totalSeconds));
  const minutes = Math.floor(safeSeconds / 60);
  const seconds = safeSeconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

export const formatDurationHMS = (totalSeconds: number): string => {
  const safeSeconds = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);
  const seconds = safeSeconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

export const formatMilliseconds = (ms: number): string => {
  return formatSecondsToMMSS(Math.floor(ms / 1000));
};

const PERSIAN_DIGITS = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

/**
 * Converts Western digits (0-9) to Persian digits (۰-۹)
 */
export const toPersianDigits = (num: number | string): string => {
  if (num === null || num === undefined) return '';
  return num.toString().replace(/\d/g, (d) => PERSIAN_DIGITS[parseInt(d, 10)]);
};

export const formatMinutesFa = (seconds: number): string =>
  seconds < 60 ? 'کمتر از ۱ دقیقه' : `${toPersianDigits(Math.round(seconds / 60))} دقیقه`;

export function formatPersianRelativeDate(dateStr?: string): string {
  if (!dateStr) return 'امروز';
  try {
    const d = new Date(dateStr);
    const now = new Date();
    const isToday =
      d.getFullYear() === now.getFullYear() &&
      d.getMonth() === now.getMonth() &&
      d.getDate() === now.getDate();
    if (isToday) return 'امروز';

    const yesterday = new Date(now.getTime() - 86400000);
    const isYesterday =
      d.getFullYear() === yesterday.getFullYear() &&
      d.getMonth() === yesterday.getMonth() &&
      d.getDate() === yesterday.getDate();
    if (isYesterday) return 'دیروز';

    return d.toLocaleDateString('fa-IR', { day: 'numeric', month: 'long' });
  } catch {
    return 'امروز';
  }
}
